// libs
import React from "react";
import { Spin } from "antd";
// others
import "./styles.less";
import LogoIcon from "../../icon/LogoIcon";

const LoadingPage = () => (
  <div className="loading-page-wrapper">
    <div className="loading-page-inner">
      <div className="loading-page-icon-wrapper">
        <LogoIcon className="loading-page-icon" />
      </div>
      <div className="loading-page-spin-wrapper">
        <Spin size="large" />
      </div>
    </div>
  </div>
);

export default LoadingPage;
